module.exports = { id: "chat", url: "/build/app/img/symbols.svg#chat", viewBox: "", toString: function() { return this.url; } };